import { z } from 'zod';

export const courtAdminstrativeUnitAssignmentSchema = z.object({
  idAssignment: z.number().default(-1),
  idCourt: z.number().nullable().default(-1),
  // #1208: Zuordnung verweist auf ein Gericht ODER eine Behörde.
  idAuthority: z.number().nullable().default(null),
  idCourtRole: z.number().default(-1),
  idFederalState: z.number().default(-1),
  idAdministrativeUnit: z.number().default(-1),
  activeAssignment: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
  // Aus Relationen
  AdministrativeUnit: z.string().optional(),
  CourtRole: z.string().optional(),
  FederalState: z.string().optional(),
  Court: z.string().nullable().optional(),
  Authority: z.string().nullable().optional(),
});

export type ICourtAdminstrativeUnitAssignment = z.infer<
  typeof courtAdminstrativeUnitAssignmentSchema
>;
